import { useQuery } from 'react-query'
import { getAuthProfile } from 'services/auth'

export function storedMemberId(): number | null {
    try {
        const profile = JSON.parse(localStorage.getItem('profile') ?? 'null')
        return typeof profile?.id === 'number' ? profile.id : null
    } catch {
        return null
    }
}

/**
 * Who «me» is on a row's `payer` / `receiver`. The profile the session stored
 * at sign-in is nearly always there; the request is only for when it is not.
 *
 * `isLoading` holds the list back while that request runs: without knowing
 * who «me» is, every installment the member paid would be drawn as somebody
 * else's for a moment and then flip.
 */
export default function useMemberId(): {
    id: number | null
    isLoading: boolean
} {
    const stored = storedMemberId()
    const { data, isLoading } = useQuery(['auth-profile'], getAuthProfile, {
        enabled: stored === null,
    })
    return {
        id: stored ?? data?.id ?? null,
        isLoading: stored === null && isLoading,
    }
}
